module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flush-left"
  }, [(_vm.label !== '') ? _c('label', {
    attrs: {
      "for": "exampleInputEmail1"
    }
  }, [_vm._v(_vm._s(_vm.label) + ":")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "copy_input",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "copy_input"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v(" "), _c('span', {
    staticClass: "input-group-append btn",
    on: {
      "click": function($event) {
        return _vm.copy()
      }
    }
  }, [_c('span', {
    staticClass: "input-group-text"
  }, [(_vm.showCheck) ? _c('i', {
    staticClass: "bi bi-check2 text-success"
  }) : _c('i', {
    staticClass: "bi bi-clipboard"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f4e7727","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CopyPasteInput.vue
// module id = 1329
// module chunks = 16